// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Enums
import type {
  CrewmemberLanguage,
} from 'common.data';
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  i18next,
} from 'common.language';

// Components
import Section from '../../../layout/Section';
import SocialAuthButtons from '../../../common/SocialAuthButtons';

// Types
import type {
  $AuthenticateAction,
} from '../../../../redux/modules/auth/actions';
import type {
  $SetupUserAction,
} from '../../../../redux/modules/main/actions';

export type $OwnProps = $Translate;

export type $StateProps = Record<string, never>;

export type $DispatchProps = {
  authenticate: $AuthenticateAction;
  setupUser: $SetupUserAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

function AuthSectionView({
  authenticate,
  setupUser,
  t,
}: $Props) {
  return (
    <Section
      className={'max-w-sm mx-auto'}
      id={webSections[webPages.profilePage].authenticate}
      title={t('Sign in / Sign up')}
    >
      <SocialAuthButtons onSuccessAction={async ({
        token,
        type,
      }) => {
        try {
          const {
            value: user,
          } = await authenticate({
            language: i18next.language as CrewmemberLanguage,
            token,
            type,
          });

          if (user !== null) {
            await setupUser(user);
          }
        } catch (error) {
          ErrorLog.exception(error as Error);
        }
      }}
      />
    </Section>
  );
}

export default AuthSectionView;
